<template>
  <v-container>
    <GuideLeadsTable />
  </v-container>
</template>

<script>
import GuideLeadsTable from "@/components/table/guide/GuideLeadsTable";
export default {
  name: "GuideLeads",
  components: {
    GuideLeadsTable,
  },
  methods: {
    handleCalls(val) {
      console.log(val);
    },
  },
};
</script>

